module.exports = __webpack_public_path__ + "img/2.5fd72f10.jpg";